import { Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';


/** 
 * Custom menu component
 *
 * Represents a custom menu component that can be used to display a list of items and emit an event when an item is selected.
 * @template T The type of the menu items. Defaults to string.
 * @example
 * <app-custom-menu [menuItems]="['item1', 'item2', 'item3']" (itemSelected)="onItemSelected($event)"></app-custom-menu>
 *
 */
@Component({
  selector: 'app-custom-menu',
  imports: [
    MatButtonModule,
    MatMenuModule,
    MatIconModule
  ],
  templateUrl: './custom-menu.component.html',
  styleUrl: './custom-menu.component.scss'
})
export class CustomMenuComponent<T = string> {

  /**
   * The menu items to display.
   * @default []
   */
  menuItems = input<T[]>();

  /**
   * The event that is emitted when an item is selected.
   * @template T The type of the menu items. Defaults to string.
   */
  itemSelected = output<T>();

  /**
   * Emits the selected item.
   * @param item The item that was selected.
   */
  menuItemSelector(item: T): void {
    this.itemSelected.emit(item);
  }

}
